export const meta = {
    data: {
        title: '',
        code: '',
        originCode: '', // origin Word or other doc
        author: 'Example Author',
        description: '',
        keywords: 'Templating, Email',
        subject: '',
        changeLog: '',
        version: '1.0',
    },
    footer: '',
};
